  // Animation variants for different elements

  export const fromLeft = {
    hidden: {
      x: -1000,
      opacity: 0,
    },
    visible: (custom) => ({
      x: 0,
      opacity: 1,
      transition: {
        delay: custom * 0.4, // Slightly longer delay between elements
        duration: 1.2, // Longer duration for smoother movement
        type: "tween", // Use "tween" for consistent speed without bounce
        damping: 30, // Controls the bounce (higher = less bounce)
        stiffness: 40, // Controls the speed (lower = smoother)
        mass: 1, // Controls the weight of the movement
        opacity: {
          duration: 1, // Separate duration for fade effect
          ease: "easeInOut", // Smooth fade in
        },
      },
    }),
  };
  export  const fromBottom = {
    hidden: {
      y: 100,
      opacity: 0,
    },
    visible: (custom) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: custom * 0.3,
        duration: 0.8,
        type: "tween",
        damping: 25,
        stiffness: 100,
      },
    }),
  };

  export  const fromRight = {
    hidden: {
      x: 500, // Moves the image to the right initially
      opacity: 0,
    },
    visible: {
      x: 0, // Moves back to the original position
      opacity: 1,
      transition: {
        duration: 1.2,
        type: "tween",
        damping: 30,
        stiffness: 70,
      },
    },
  };
  export  const scaleFromRightCorner = {
    hidden: {
      x: 500, // Move to the right initially
      y: -300, // Move upwards initially
      scale: 0.2, // Start with a smaller size
      opacity: 0,
    },
    visible: {
      x: 0,
      y: 0,
      scale: 1,
      opacity: 1,
      transition: {
        duration: 1.5,
        type: "tween",
        damping: 30,
        stiffness: 50,
      },
    },
  };

  export  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: (custom) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: custom * 0.3,
        duration: 0.6,
        type: "spring",
        damping: 20,
        stiffness: 90,
      },
    }),
  };